export default "__VITE_ASSET__CxSmp5zN__"